import { css } from 'styled-components';
import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';

export const suggestion: ThemedFunctor = ({
  theme,
}) => css`
  display: flex;
  align-items: center;
  color: ${theme.palettes.neutrals.medium};
`;

export const suggestionLabel: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginLeft(theme, SpacingName.SMALLEST)}
  color: ${theme.palettes.neutrals.darkest};
`;
